module.exports = __webpack_public_path__ + "img/leval-5.ed1d7a3d.png";